import React, { useState, useEffect } from "react"
import { Link, useLocation, useHistory } from "react-router-dom"
import { Col, Row, FormGroup, Label, Container } from "reactstrap"

import { contracts } from "../../Pages/NFTSale/utils"
import { networkIcons } from "../../utils"
import "./NftCard.scss"

const ZkNftCard = ({ nft, idx, enableClickNFT = true }) => {
    // if enableClickNFT == true, clicking on this component will redirect to nft details page
    // { nft, idx, enableClickNFT = true }
    // const { state } = props.location
    // const { nft, idx } = state
    const history = useHistory()
    const collectionAddress = "collectionAddress"
    const chain = "zksync"
    // const contractOwner = contracts[subdomain]?.[contractType]?.owner
    const collectionSymbol = "ZKAC"
    const elementLink = "https://element.market/assets/zksync/0xd0767d49e0e30b8fb4484d86f0bd1f80abc3e74c/"
    const explorerLink = "https://era.zksync.network/nft/0xd0767d49e0e30b8fb4484d86f0bd1f80abc3e74c/"

    // const location = useLocation()
    // const { nftOne, idxOne } = location.state

    const [showImageLoading, setShowImageLoading] = useState(true)

    // useEffect(() => {
    //     // Extract the NFT ID or other identifying parameter from the URL
    //     console.log("got to card")
    //     }, []);

    return (
        <React.Fragment>
            <Row>
                {/* Image Column */}
                <Col md="4" className="image-column">
                    <div className="image-wrap">
                        <img
                            src={nft.metadata.image}
                            onLoad={() => setShowImageLoading(false)}
                            alt={nft.name}
                            className={showImageLoading ? " hide" : ""}
                            style={{ maxWidth: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                </Col>

                {/* Details Column */}

                <Col md="8" className="details-column">
                    {/* Adjusted Details Column for side-by-side layout */}
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Name:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {nft?.metadata.name}
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Description:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {nft.metadata.description}
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Token ID:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {nft?.tokenId}
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Block Explorer:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            <span>
                                <a href={explorerLink + nft?.tokenId} target="_blank" rel="noopener noreferrer">
                                    {explorerLink + nft?.tokenId}
                                </a>
                            </span>
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Element:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            <span>
                                <a href={elementLink + nft?.tokenId} target="_blank" rel="noopener noreferrer">
                                    {elementLink + nft?.tokenId}
                                </a>
                            </span>
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>TokenURI:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            <span>
                                <a href={nft?.tokenURI} target="_blank" rel="noopener noreferrer">
                                    {nft?.tokenURI}
                                </a>
                            </span>
                        </Col>
                    </Row>
                    <div className="nft-label attributes">
                        <strong>Attributes:</strong>
                    </div>
                    {nft?.metadata.attributes
                        ? nft.metadata.attributes.map((item) => {
                              return (
                                  <Row className="detail-row">
                                      <Col md="3" className="detail-label">
                                          {item.trait_type}:
                                      </Col>
                                      <Col md="9" className="detail-value">
                                          {item.value}
                                      </Col>
                                  </Row>
                              )
                          })
                        : null}
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ZkNftCard
